var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackSmLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#191713"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.04045 19.1998H8.02654V9.57618H5.04045V19.1998ZM4.80078 6.53237C4.80078 7.48922 5.57481 8.26494 6.5335 8.26494C7.48826 8.26494 8.26228 7.48529 8.26228 6.53237C8.26228 5.57552 7.48826 4.7998 6.5335 4.7998C5.57481 4.7998 4.80078 5.57552 4.80078 6.53237ZM16.2186 19.1998H19.2008V13.9194C19.2008 11.3284 18.6429 9.33598 15.6214 9.33598C14.1716 9.33598 13.1972 10.1353 12.8003 10.8914H12.7611V9.57618H9.9007V19.1998H12.8789V14.4431C12.8789 13.187 13.1147 11.9703 14.6666 11.9703C16.199 11.9703 16.2186 13.4075 16.2186 14.5219V19.1998Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackSmLinkedin);
export default __webpack_public_path__ + "static/media/black-sm-linkedin.7caef00286c683c9596992330936b3b9.svg";
export { ForwardRef as ReactComponent };